import request from '@/utils/request';

const requestInstance = request();

/**
 * 获取添加插件的信息
 */
export function getAddInfo(params) {
  return requestInstance.post('/api/apiPlugins/getPluginAddPageDetail', params);
}
/**
 * 更新插件状态
 */
export function updateStatus(params) {
  return requestInstance.post('/api/apiPlugins/updatePluginStatus', params);
}
/**
 * 更新订单详情
 */
export function getOrderDetail() {
  return requestInstance.post('/api/apiPlugins/getOrderQueryToolPluginDetail');
}

/**
 * 获取接口地址
 */
export function getInterface() {
  return requestInstance.post('/api/apiPlugins/getSchemeListPluginDetail', {});
}
